import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class HolidayCalendar extends Base implements EntityType {
    holidayCalendarId: uuid;
    name: string;
    holidayDate: Date;
    recurring: boolean;
    jurisdiction?: string | null;
    enabled: boolean;
    constructor(doc: typeof HolidayCalendar | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            holidayCalendarId: genUUID(),
            name: null,
            holidayDate: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "holidayCalendar";
        // @ts-ignore
        this.holidayCalendarId = doc._holidayCalendarId || doc.holidayCalendarId || doc.holidaycalendarid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.holidayDate = DateUtil.dateOnly(doc._holidayDate) || DateUtil.dateOnly(doc.holidayDate) || DateUtil.dateOnly(doc.holidaydate) || null;
        // @ts-ignore
        this.recurring = util.defaultBoolean([doc.recurring, doc._recurring, doc.recurring, false]);
        // @ts-ignore
        this.jurisdiction = doc._jurisdiction || doc.jurisdiction || null;
        // @ts-ignore
        this.enabled = util.defaultBoolean([doc.enabled, doc._enabled, doc.enabled, true]);
    }
    get id(): uuid { return this.holidayCalendarId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique id for this holiday"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.holidayCalendarId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): HolidayCalendar[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'holidayCalendar',
    table: 'HOLIDAY_CALENDAR',
    comment: 'A firm-level holiday entry used to define non-working days for the firm. Holidays can recur annually or be one-time dates and are scoped to a jurisdiction (Federal, TX, CA, etc.). They are consumed by the deadline calculator to skip non-business days and by productivity reports to compute working-day targets. Holiday packs (US Federal and state-specific) can be imported from Gusto or added manually.',
    fields: {
        holidayCalendarId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique id for this holiday'
        },

        /**
         * Display name, e.g. "Thanksgiving", "Christmas Day"
         */
        name: {
            type: 'string',
            required: true,
            searchable: true,
            comment: 'Holiday name'
        },

        /**
         * The date of the holiday
         */
        holidayDate: {
            type: 'date',
            required: true,
            comment: 'The holiday date'
        },

        /**
         * If true, this holiday recurs on the same date every year
         */
        recurring: {
            type: 'boolean',
            default: false,
            comment: 'Does this holiday recur annually?'
        },

        /**
         * Jurisdiction this holiday applies to, e.g. "Federal", "TX", "CA", "NY"
         */
        jurisdiction: {
            type: 'string',
            comment: 'Jurisdiction: Federal, TX, CA, NY, etc.'
        },

        /**
         * Whether this holiday is active for this firm
         */
        enabled: {
            type: 'boolean',
            default: true,
            comment: 'Is this holiday active for this firm?'
        }
    },
    indexes: [
        {name: 'notDeleted', fn: s => s.status !== 'D'},
        {name: 'enabled', fn: s => s.enabled !== false && s.status !== 'D'}
    ],
    maps: [
        {
            name: 'jurisdiction',
            keysFn: s => s.jurisdiction,
            presentFn: (s, k) => s.jurisdiction === k && s.status !== 'D'
        }
    ]
});
    }
}
export default HolidayCalendar;
